/**
 * AnimatedSection
 * ---------------
 * Wrapper component that uses IntersectionObserver (via useScrollAnimation hook)
 * to apply a fade-up animation when the element enters the viewport.
 *
 * Props:
 *   - children:    React nodes to render inside the section
 *   - className:   Optional extra class names
 *   - delay:       CSS transition-delay in ms (for staggered animations)
 *   - animation:   'fade-up' (default) | 'fade-in' | 'slide-right'
 *   - threshold:   IntersectionObserver threshold (default 0.1)
 *   - tag:         HTML element to render (default 'div')
 */
import useScrollAnimation from '../../hooks/useScrollAnimation';
import styles from './AnimatedSection.module.css';

const AnimatedSection = ({
  children,
  className = '',
  delay = 0,
  animation = 'fade-up',
  threshold = 0.1,
  tag: Tag = 'div',
}) => {
  const [ref, isVisible] = useScrollAnimation(threshold);

  return (
    <Tag
      ref={ref}
      className={`${styles.base} ${styles[animation]} ${isVisible ? styles.visible : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
};

export default AnimatedSection;
